module.exports = __webpack_public_path__ + "static/media/store_week_ru.6b06dce2.svg";